









































import { Ref, Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { Project } from '@/api/model/project'
import { ProviderInstance } from 'vee-validate/dist/types/types'

@Component
export default class InputSelectProject extends Vue {
    @Ref() validator!: ProviderInstance
    @Ref() optionsContainer!: HTMLDivElement
    @Prop({ default: null }) readonly rules!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly projects!: Project[]
    @Prop() readonly value!: Project
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    @Prop({ type: Boolean, default: false }) readonly clearable!: boolean
    @Prop({ type: Boolean, default: false }) readonly white!: boolean
    @Prop({ type: Boolean, default: false }) readonly sm!: boolean
    @Prop({ type: Boolean, default: false }) readonly rounded!: boolean
    internalValue: Project = null
    showOptions: boolean = false

    created() {
        this.internalValue = this.value
        window.addEventListener('click', this.onOutsideClick)
    }

    mounted() {
        this.calculateOptionsTop()
    }

    beforeDestroy() {
        window.removeEventListener('click', this.onOutsideClick)
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.value
    }

    @Watch('internalValue')
    async onInput(): Promise<void> {
        await this.validator.validate(this.internalValue)
        this.$emit('input', this.internalValue)
    }

    applyClass(option: Project) {
        if (this.value && this.value.id === option.id) {
            return ['input-select__option--selected']
        }

        return []
    }

    toggleOptions(): void {
        if (!this.disabled) {
            this.showOptions = !this.showOptions
        }
    }

    selectOption(option: Project): void {
        this.internalValue = option
        this.showOptions = false
    }

    get isClearable(): boolean {
        return this.clearable && this.internalValue !== null && !this.disabled
    }

    /**
     * Deactivated projects are left out entirely; they are reactivated in the projects
     * settings when needed. A referral that is already linked to a deactivated project keeps
     * that one in the list, otherwise its selection would look empty.
     */
    get availableProjects(): Project[] {
        const projects = (this.projects ?? []).filter(project => project.active)

        if (this.value && !projects.some(project => project.id === this.value.id)) {
            projects.unshift(this.value)
        }

        return projects
    }

    get selectedOption() {
        if (!this.value) {
            return null
        }

        return (this.projects ?? []).find(value => value.id === this.value.id) ?? this.value
    }

    get selectedOptionIndex() {
        if (!this.internalValue) {
            return null
        }

        return this.availableProjects.findIndex(value => value.id === this.internalValue.id)
    }

    optionsTop: number = 0

    @Watch('selectedOptionIndex')
    calculateOptionsTop() {
        this.optionsTop = -10
    }

    get componentClass(): object {
        return {
            'input-select': true,
            'input-select--sm': this.sm,
            'input-select--disabled': this.disabled,
            'input-select--white': this.white,
            'input-select--rounded': this.rounded,
        }
    }

    async onOutsideClick(e: Event) {
        const target = e.target as HTMLDivElement

        if (!this.$el.contains(target)) {
            this.showOptions = false
        }
    }
}
